<template>
    <div>
        <b-row>
            <b-col md="6">
                <p>
                    DO NOT setup any taxes here unless your local, state or provincial taxing authority requires the
                    collection of taxes on commissions and / or fees that are assessed to the property owner.
                </p>
                <p>
                    Any taxes setup up here will be direct line item reductions on the owner statement from any rental
                    monies that are owed to the property owner after deduction of commissions and fees.
                </p>
                <p>All taxes setup here will apply to all properties for this property owner.</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <validation-observer ref="form" v-slot="{ meta, handleSubmit, errors }" :initial-values="values">
                    <b-form @submit.prevent="handleSubmit(_, save)">
                        <b-row>
                            <b-col md="4">
                                <validation-provider name="hst_tax_name">
                                    <form-input
                                        floating-label="Name of Tax"
                                        placeholder="Name of Tax"
                                        v-model="values.hst_tax_name"
                                        :error="errors.hst_tax_name"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <validation-provider name="hst_tax" v-slot="{ handleChange }" rules="required">
                                    <form-input
                                        floating-label="Tax"
                                        placeholder="Tax"
                                        v-model="values.hst_tax"
                                        :error="errors.hst_tax"
                                        @input="handleChange"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group>
                                    <form-switch v-model="values.apply_hst_to_fees" />
                                    <label>Apply to Fees</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group>
                                    <form-switch v-model="values.apply_hst_to_commissions" />
                                    <label>Apply to Commmisions</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-button class="mt-4" type="submit" variant="primary" :disabled="loading || !meta.valid">
                            Save
                        </b-button>
                    </b-form>
                </validation-observer>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import FormInput from '../../generic/form-input/form-input.vue';
import FormSwitch from '../../generic/form-switch/form-switch.vue';
import { formatResponseError } from '../../../utils/api';

export default {
    name: 'OwnerEditTaxes',
    components: {
        FormInput,
        FormSwitch,
    },
    props: {
        owner: Object,
    },
    data() {
        return {
            loading: false,
            values: this.getInitialValues(),
        };
    },
    methods: {
        getInitialValues() {
            return {
                hst_tax: this.owner.hst_tax
                    ? this.owner.hst_tax_is_flat
                        ? this.owner.hst_tax
                        : `${this.owner.hst_tax}%`
                    : 0,
                hst_tax_name: this.owner.hst_tax_name || '',
                apply_hst_to_commissions: this.owner.apply_hst_to_commissions || false,
                apply_hst_to_fees: this.owner.apply_hst_to_fees || false,
            };
        },
        async save() {
            this.loading = true;

            try {
                await this.$store.dispatch('owner/updateTaxes', {
                    id: this.owner.id,
                    ...this.values,
                });
                this.successToast({ text: `Taxes information has been saved successfully.` });
            } catch (err) {
                const { generic, fields } = formatResponseError(err);

                if (generic) {
                    this.errorToast({ text: generic });
                }
                if (!isEmpty(fields)) {
                    this.$refs.form.setErrors(fields);
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
